import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import { ApiError } from './lib/api'
import './styles/tokens.css'
import './styles/base.css'
import { ToastProvider } from './ui'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Ein abgelaufener Zugang wird nicht durch Wiederholen besser. Bei
      // Serverfehlern lohnt genau ein zweiter Versuch — mehr verlängert nur
      // den Ladebalken.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false
        return failureCount < 1
      },
      refetchOnWindowFocus: true,
      staleTime: 15_000,
    },
    mutations: { retry: false },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <App />
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
